/** Rota `/cadastro/:recurso/:id` — resolve o descriptor e abre a edição em tela cheia. */
import { Navigate, useParams } from 'react-router-dom';
import { EdicaoRecurso } from '@/components/crud/EdicaoRecurso';
import { obterRecurso } from '@/lib/recursos';

export function RecursoEdicao() {
  const { recurso, id } = useParams();
  const descritor = obterRecurso(recurso);
  if (!descritor || !id) return <Navigate to="/cadastro" replace />;
  return <EdicaoRecurso key={id} descritor={descritor} id={id} />;
}
